import { Stack } from "@mui/material";
import { useContext } from "react";
import AddCommentBox from "./add-comment-box";
import CommentBox from "./comment-box";
import { CandidateProfileContext } from "../context/candidate-profile-context";

export default function Notes(){
  const candidateDetails = useContext(CandidateProfileContext)?.obj;

  const notes = candidateDetails?.candidate_notes;

  return(
    <Stack spacing="32px" pb="24px">
      <AddCommentBox mode="CREATE" />
      {
        notes?.map((note, index) => (
          <CommentBox key={index} comment={note}/>
        ))
      }
    </Stack>
  )
}
